import { PopupKind } from "@/utill/enumerations";

/*
 * TODO: 원래 기본으로 전송 버튼을 막아두고 CSS 도 회색 처리한 다음
 *       체크할 validation 이 모두 성공인 경우 자동으로 녹색에 전송 가능하게
 *       풀어주려 했으나 그거까지 하기엔 힘들어서 그 부분은 처리하지 않음.
 * */
const state = () => ({
  isOpened: false,
  leftButtonExposure: false,
  popupKind: PopupKind.CREATE,
  // preventSubmit: true,
  preventSubmit: false,
});

const getters = {
  getPopupIsOpened: (state) => state.isOpened,
  getPopupLBtnExposure: (state) => state.leftButtonExposure,
  getPopupKind: (state) => state.popupKind,
  getPreventSubmit: (state) => state.preventSubmit,
};

const mutations = {
  popupToggle(
    state,
    options /*: {
                   popupKind: PopupKind,
                   leftButton: false
                 },*/
  ) {
    // 1. popup open toggle
    state.isOpened = !state.isOpened;
    state.preventSubmit = false;

    // 2. judge left button exposure
    if (
      Object.prototype.hasOwnProperty.call(options, "leftButton") &&
      typeof options["leftButton"] === "boolean"
    ) {
      // Force
      state.leftButtonExposure = options.leftButton; // boolean
    } else {
      // Relative
      state.leftButtonExposure = options.popupKind !== PopupKind.CREATE;
    }
    // 3. CREATE or UPDATE
    state.popupKind = options.popupKind;
  },
};

const actions = {};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
